import { render } from "./DiscoverInfluencers.vue?vue&type=template&id=87f57558&scoped=true"
import script from "./DiscoverInfluencers.vue?vue&type=script&lang=js"
export * from "./DiscoverInfluencers.vue?vue&type=script&lang=js"

import "./DiscoverInfluencers.vue?vue&type=style&index=0&id=87f57558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f57558"]])

export default __exports__